module.exports = __webpack_public_path__ + "img/nf.f1d86710.png";